import type { SpartanCustomizeModelColor } from '@/app/lcv/components/sections/spartan/products/customize/types';
import { GRADIENT_COLORS } from '@/services/contentstack/models/lcv-color';

export const getSpartanCustomizeColorId = (
  color?: SpartanCustomizeModelColor | null
) => color?.color?.title ?? color?.documentId ?? '';

export const getSpartanCustomizeColorName = (
  color?: SpartanCustomizeModelColor | null
) => color?.color?.nameTh ?? color?.title ?? '';

export const getSpartanCustomizeColorHex = (
  color: SpartanCustomizeModelColor
): string => {
  const colorCode = color.color?.colorCode?.trim() ?? '';
  if (colorCode) {
    return colorCode.startsWith('#') ? colorCode : `#${colorCode}`;
  }

  const colorId = getSpartanCustomizeColorId(color);
  return GRADIENT_COLORS[colorId as keyof typeof GRADIENT_COLORS] ?? '';
};

const SPARTAN_CUSTOMIZE_COLOR_SHEEN =
  'linear-gradient(160deg, rgba(255, 255, 255, 0.7) 10.23%, rgba(255, 255, 255, 0.4) 30.99%, rgba(255, 255, 255, 0.2) 43.44%, rgba(0, 0, 0, 0.1) 44.28%, rgba(0, 0, 0, 0) 60.05%, rgba(255, 255, 255, 0) 93.27%)';

const SPARTAN_CUSTOMIZE_COLOR_TWO_TONE_EDGE =
  'linear-gradient(90deg, rgba(0, 0, 0, 0) 69%, rgba(0, 0, 0, 0.7) 70%, #000000 100%)';

/** Premium rectangular paint chip: standard sheen or sheen + dark right-edge two-tone. */
export const getSpartanCustomizeColorSwatchBackground = (
  hex: string,
  twoToneSolidColor?: string
) => {
  if (twoToneSolidColor) {
    return [
      SPARTAN_CUSTOMIZE_COLOR_SHEEN,
      SPARTAN_CUSTOMIZE_COLOR_TWO_TONE_EDGE,
      hex,
    ].join(', ');
  }

  return [SPARTAN_CUSTOMIZE_COLOR_SHEEN, hex].join(', ');
};
